import { createContext, useContext } from 'react';
import { useDataFetching } from '../hooks/useDataFetching';
import { useLocale } from '../hooks/useLocale';
import { useActiveOption } from '../hooks/useActiveOption';
import { useExpanded } from '../hooks/useExpanded';

const StateContext = createContext(null);

const AppState = (props) => {
  const { data, loading, error } = useDataFetching();
  const { locale } = useLocale();
  const { activeOption, setActiveOption } = useActiveOption();
  const { expanded, setExpanded } = useExpanded();

  const value = {
    // Data
    adData: data?.adData || null,
    videoData: data?.videoData || null,
    config: data?.config || null,
    copy: data?.copy || null,
    adSizes: data?.adSizes || [],
    
    // State
    ready: !loading && !error && data !== null,
    loading,
    error,
    locale,
    activeOption,
    setActiveOption,
    expanded,
    setExpanded,
  };

  return <StateContext.Provider value={value}>{props.children}</StateContext.Provider>;
};

export const useAppState = () => useContext(StateContext);
export default AppState;
